module.exports = __webpack_public_path__ + "static/media/imgTarget.fcbcc22d.svg";